import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const crmLeadsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/crm/leads",
  component: lazyRouteComponent(() => import("./crm-leads.page.js"), "CrmLeadsPage"),
});
